const ADMIN_HOST = "cloudfront.haoxuexingcheng.com";
const PORTAL_HOST = "cloud.haoxuexingcheng.com";
/** 本地联调 deploy/start_local.ps1：用户门户 9001、管理端 9002 */
const LOCAL_PORTAL_PORT = "9001";
const LOCAL_ADMIN_PORT = "9002";

function currentHost() {
  if (typeof window === "undefined" || !window.location) return "";
  return (window.location.hostname || "").toLowerCase();
}

function currentPort() {
  if (typeof window === "undefined" || !window.location) return "";
  return String(window.location.port || "");
}

export function isAdminDomain() {
  if (currentHost() === ADMIN_HOST) return true;
  return currentPort() === LOCAL_ADMIN_PORT;
}

export function isPortalDomain() {
  if (currentHost() === PORTAL_HOST) return true;
  return currentPort() === LOCAL_PORTAL_PORT;
}

export function resolveLoginPath() {
  return isAdminDomain() ? "/admin/login" : "/index";
}

